import { CSSProperties } from "react";
import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { NSCard, NSCardGrid } from "namirasoft-site-react";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";
import { AccessRoutes } from "../AccessRoutes";
import IncomingPermissionSwitcher from "../components/IncomingPermissionSwitcher";

const stackStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
    width: "100%",
    maxWidth: 960,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: 16,
    paddingRight: 16
};

export default function HomePage(props: NSARouterMakerResult & AccessProps)
{
    return (
        <AccessLayout {...props}>
            <NSAHomePage
                {...props}
                getChildren={{
                    getChildrenBefore: () => (
                        <div style={stackStyle}>
                            <IncomingPermissionSwitcher {...props} />
                            <NSCardGrid>
                                <NSCard
                                    title="Policies"
                                    description="A list of custom permission policies tailored to your needs."
                                    link={{ href: AccessRoutes.PolicyList, target: "_self" }}
                                    classList={["h-100 shadow"]}
                                />
                                <NSCard
                                    title="Roles"
                                    description="A list of specific roles to be assigned to users for streamlined permission management."
                                    link={{ href: AccessRoutes.RoleList, target: "_self" }}
                                    classList={["h-100 shadow"]}
                                />
                                <NSCard
                                    title="Outgoing Permissions"
                                    description="A list of permissions you've granted to other users for your account, helping you track them for privacy and security."
                                    link={{ href: AccessRoutes.OutgoingPermissionList, target: "_self" }}
                                    classList={["h-100 shadow"]}
                                />
                                <NSCard
                                    title="Incoming Permissions"
                                    description="A list of permissions other users have granted you for their accounts."
                                    link={{ href: AccessRoutes.IncomingPermissionList, target: "_self" }}
                                    classList={["h-100 shadow"]}
                                />
                            </NSCardGrid>
                        </div>
                    )
                }}
            />
        </AccessLayout>
    );
}